import { FC, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

import "./Link.css";

import { RouteKey, RoutePath } from "../configs/routes";

export interface LinkProps {
  route: RouteKey;
  children: ReactNode;
  className?: string;
}

export const Link: FC<LinkProps> = ({ route, children, className }) => (
  <RouterLink to={RoutePath[route]} className={`link ${className || ""}`}>
    {children}
  </RouterLink>
)